<template>
  <span>{{ animatedNumber }}</span>
</template>

<script>
export default {
  name: 'AnimatedNumber',
  props: {
    modelValue: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      animatedNumber: 0
    }
  },
  watch: {
    modelValue (newValue, oldValue) {
      let timeCnt = 0
      let timerId = null
      const animate = () => {
        timeCnt++
        if (timeCnt <= 30) {
          this.animatedNumber = Math.floor((newValue - oldValue) * timeCnt / 30) + oldValue
          timerId = setTimeout(() => {
            animate()
          }, 10)
        } else {
          clearTimeout(timerId)
          timerId = null
          this.animatedNumber = newValue
        }
      }
      animate()
    }
  },
  mounted () {
    this.animatedNumber = this.modelValue
  }
}
</script>
